// @flow
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import RatingSelector from './RatingSelector';

import { selectSelectedCaptions } from '../../selectors/scribe-session';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  heading: {
    fontSize: 24,
    fontWeight: 400,
    lineHeight: '31px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  text: {
    fontSize: 20,
    lineHeight: '26px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  ratingContainer: {
    margin: '0 auto',
  },
  ratingText: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  terribleText: {
    color: theme.palette.ava.red2,
  },
  amazingText: {
    color: theme.palette.ava.scribe2,
  },
}));

interface Props {
  rate?: number;
  rateHover?: number;
  onRateChange: Function;
  onRateHover: Function;
}

const RatingContent = ({ rate, rateHover, onRateChange, onRateHover }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const selectedCaptions = useSelector(selectSelectedCaptions);

  const getRatingHeading = () => {
    if (selectedCaptions === 'free') {
      return t('rateConversation.heading.free');
    }
    if (selectedCaptions === 'premium') {
      return t('rateConversation.heading.premium');
    }
    return t('rateConversation.heading.scribe');
  };

  return (
    <div className={classes.content}>
      <h5 className={classes.heading}>{getRatingHeading()}</h5>
      <p className={classes.text}>{t('rateConversation.howDidAvaWorkForYou')}</p>
      <div className={classes.ratingContainer}>
        <RatingSelector
          initialRating={rate}
          onChange={onRateChange}
          onHover={onRateHover}
          rating={rateHover || rate || 0}
          readonly={!!rate}
        />
        <div className={classnames(classes.text, classes.ratingText)}>
          <span className={classes.terribleText}>{t('rateConversation.terrible')}</span>
          <span className={classes.amazingText}>{t('rateConversation.amazing')}</span>
        </div>
      </div>
    </div>
  );
};

export default RatingContent;
